var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1609,
    height: 909,
    viewBox: "0 0 1609 909",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1435 99.999C1439.42 99.999 1443 96.4173 1443 91.999C1443 87.5807 1439.42 83.999 1435 83.999C1430.58 83.999 1427 87.5807 1427 91.999C1427 96.4173 1430.58 99.999 1435 99.999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 837.999C17.0751 837.999 22 833.074 22 826.999C22 820.924 17.0751 815.999 11 815.999C4.92487 815.999 0 820.924 0 826.999C0 833.074 4.92487 837.999 11 837.999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 144.999C77.4183 144.999 81 141.417 81 136.999C81 132.581 77.4183 128.999 73 128.999C68.5817 128.999 65 132.581 65 136.999C65 141.417 68.5817 144.999 73 144.999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1594 864.999C1602.28 864.999 1609 858.283 1609 849.999C1609 841.715 1602.28 834.999 1594 834.999C1585.72 834.999 1579 841.715 1579 849.999C1579 858.283 1585.72 864.999 1594 864.999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 908.999C91.866 908.999 95 905.865 95 901.999C95 898.133 91.866 894.999 88 894.999C84.134 894.999 81 898.133 81 901.999C81 905.865 84.134 908.999 88 908.999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M325.5 24.999C332.404 24.999 338 19.4026 338 12.499C338 5.59546 332.404 -0.000976562 325.5 -0.000976562C318.596 -0.000976562 313 5.59546 313 12.499C313 19.4026 318.596 24.999 325.5 24.999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.5f1feb9eaf370437be60f37c2f22f2f5.svg";
export { ForwardRef as ReactComponent };